import { cx } from "../lib/classNames";
import { useTranslation } from "../i18n";

/**
 * A shimmering placeholder block. Compose several to mirror the shape of the
 * content being loaded — far less jarring than a "Loading…" text swap.
 */
export function Skeleton({ className }: { readonly className?: string }) {
  return (
    <div
      aria-hidden="true"
      className={cx("animate-pulse rounded bg-slate-800/80", className)}
    />
  );
}

/** A vertical stack of full-width skeleton lines — handy for table/list loads. */
export function SkeletonRows({
  rows = 3,
  className,
}: {
  readonly rows?: number;
  readonly className?: string;
}) {
  const { t } = useTranslation("app");
  return (
    <div className={cx("space-y-2", className)} role="status" aria-label={t("loading")}>
      {Array.from({ length: rows }, (_, i) => (
        <Skeleton key={i} className="h-10 w-full" />
      ))}
    </div>
  );
}
